import MartyrServices from '../../services/health_card/martyr';

export const state = {
    martyrs: [],
    martyr: {},
}

export const mutations = {
    setMartyr(state, martyr) {
        state.martyr = martyr
    },
    setMartyrs(state, martyrs) {
        state.martyrs = martyrs
    }
}

export const getters = {
    getMartyr(state) {
        return state.martyr;
    },
    getMartyrs(state) {
        return state.martyrs;
    },
}

export const actions = {
    get({commit}, id){
        return MartyrServices.get(id)
        .then((response)=>{
            commit('setMartyr', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return MartyrServices.getAll(data)
        .then((response)=>{
            commit('setMartyrs', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return MartyrServices.delete(id)
        .then((response)=>{
            commit('setMartyrs', state.martyrs.filter((x)=>x.id != id))
            return response
        })
    },
}